import { useGetIsUngated } from './useGetIsUngated';
import { GATES } from '../constants/auth';
export const useHasChangesRequested = () => {
  const getIsUngated = useGetIsUngated();
  return getIsUngated(GATES.CHANGES_REQUESTED) || getIsUngated(GATES.AGENT_APPROVER) || getIsUngated(GATES.PAGE_EDITOR_AI_EDITING_EXPERIMENT) && getIsUngated(GATES.EDITOR_V2_APPROVALS);
};